import React from 'react';
import { Coffee } from 'lucide-react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
  showFallback?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className = '', 
  showFallback = true 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
    '2xl': 'h-24 w-24'
  };

  const fallbackSizes = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
    '2xl': 'h-16 w-16'
  };

  // Choose the best logo size for the requested size
  const getLogoSrc = (size: string) => {
    switch (size) {
      case 'sm': return '/logo-32.png';
      case 'md': return '/logo-64.png';
      case 'lg': return '/logo-128.png';
      case 'xl': return '/logo-256.png';
      case '2xl': return '/logo-256.png';
      default: return '/logo.png';
    }
  };

  return (
    <>
      <img 
        src={getLogoSrc(size)}
        alt="Kiss Coffee Logo" 
        className={`${sizeClasses[size]} object-contain ${className}`}
        style={{
          imageRendering: 'crisp-edges',
          filter: 'contrast(1.1) saturate(1.1)',
          WebkitFilter: 'contrast(1.1) saturate(1.1)'
        } as React.CSSProperties}
        onError={(e) => {
          // Fallback to main logo if size-specific logo not found
          if (e.currentTarget.src !== '/logo.png') {
            e.currentTarget.src = '/logo.png';
            return;
          }
          // Then fallback to coffee icon
          if (showFallback) {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }
        }}
      />
      {showFallback && (
        <Coffee className={`${fallbackSizes[size]} text-red-500 hidden`} />
      )}
    </>
  );
};

export default Logo;
